import { useSelector } from 'react-redux';

const useIsLearningManager = () => {
  const user = useSelector((state) => state.authSlice?.userData);
  return user?.learningRoles?.includes('TRAINER_MANAGER') || false;
};

export default useIsLearningManager;
// example usage
